import https from "../common/https";
import { AxiosRequestConfig } from "axios";
import { IServerGenericResponse } from "../common/common-models";
import { CONFIG } from "../common/config";

export class LoginData {
  public login(userName: string, password: string): Promise<string> {
    const formData = new FormData();
    formData.append("log", userName);
    formData.append("pwd", password);
    formData.append("interim-login", "1");
    const axiosRequestConfig: AxiosRequestConfig = {
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
    };
    return https.post(
      CONFIG.E4S_HOST + "/wp-login.php",
      formData,
      axiosRequestConfig,
    );
  }

  public logout(logoutUrl: string) {
    return https.get(logoutUrl);
  }

  public register(
    userName: string,
    email: string,
  ): Promise<IServerGenericResponse> {
    return https.post(CONFIG.E4S_HOST + "/wp-json/e4s/v5/register", {
      name: userName,
      email,
    });
  }

  public newUser(): Promise<unknown> {
    return https.get(CONFIG.E4S_HOST + "/wp-json/e4s/v5/public/newuser");
  }

  //  Fields we set ourselves, plus object prototype keys. Server supplied
  //  fields must never replace these.
  private static readonly RESERVED_PAYLOAD_KEYS: ReadonlySet<string> = new Set([
    "name",
    "email",
    "password",
    "website_url",
    "__proto__",
    "constructor",
    "prototype",
  ]);

  public registerV2(
    userName: string,
    email: string,
    password: string,
    website_url: string,
    newUser: unknown,
  ): Promise<IServerGenericResponse> {
    const payload: Record<string, unknown> = {
      name: userName,
      email,
      password,
      website_url,
      ...LoginData.extractNewUserFields(newUser),
    };

    return https.post(CONFIG.E4S_HOST + "/wp-json/e4s/v5/register", payload);
  }

  //  newUser is an object of extra fields supplied by the server, e.g.
  //  {a: 12, b: "etc"}. Copy only keys we did not set ourselves, so server
  //  data can never overwrite the credentials above.
  private static extractNewUserFields(
    newUser: unknown,
  ): Record<string, unknown> {
    const fields: Record<string, unknown> = {};

    if (
      typeof newUser !== "object" ||
      newUser === null ||
      Array.isArray(newUser)
    ) {
      return fields;
    }

    Object.entries(newUser).forEach(([key, value]) => {
      if (value === undefined) return;
      if (LoginData.RESERVED_PAYLOAD_KEYS.has(key)) return;
      fields[key] = value;
    });

    return fields;
  }

  public requestPasswordReset(email: string): Promise<IServerGenericResponse> {
    return https.post(
      CONFIG.E4S_HOST + "/wp-json/e4s/v5/public/pwdresetrequest",
      { key: email },
    );
  }

  public resetPassword(
    userIdentifier: string,
    resetKey: string,
    password: string,
    website_url: string = "",
  ): Promise<IServerGenericResponse> {
    return https.post(CONFIG.E4S_HOST + "/wp-json/e4s/v5/public/pwdreset", {
      key: resetKey,
      login: userIdentifier,
      pwd: password,
      website_url: website_url,
    });
  }
}
